import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const Container = ({ children, fullWidth, fullBleed, className, ...other }) => (
  <div
    className={classNames(
      'container',
      fullWidth && 'container--full-width',
      fullBleed && 'container--full-bleed',
      className
    )}
    {...other}
  >
    {children}
  </div>
);

Container.defaultProps = {
  className: null,
  fullWidth: false,
  fullBleed: false,
};

Container.propTypes = {
  /** A custom class name. */
  className: PropTypes.string,
  /** Prevent the narrow container on mobile and tablet */
  fullWidth: PropTypes.bool,
  /** Remove padding from container, rowand column */
  fullBleed: PropTypes.bool,
};

export default Container;
